import { createContext, type PropsWithChildren } from 'react';

import {
  LANGUAGE_DEFAULT,
  LANGUAGE_LOCALE_DEFAULT,
} from 'src/app/constants/language';
import { SITE_DEFAULT } from 'src/app/constants/site';

import type { ConfigOptions } from './types';

export const defaultConfig: ConfigOptions = {
  language: LANGUAGE_DEFAULT,
  locale: LANGUAGE_LOCALE_DEFAULT,
  site: SITE_DEFAULT,
};

export const ExpressUIConfigContext = createContext<ConfigOptions>({
  ...defaultConfig,
});

export type ExpressUIConfigProviderProps = {
  config: ConfigOptions;
};

export const ExpressUIConfigProvider = ({
  config,
  children,
}: PropsWithChildren<ExpressUIConfigProviderProps>) => (
  <ExpressUIConfigContext.Provider value={{ ...config }}>
    {children}
  </ExpressUIConfigContext.Provider>
);
